import { Component } from 'react';

/**
 * region for helpers*/
import typing from '../../helpers/typing';
import validation from '../../helpers/validation';

export class BaseInput extends Component {
    static displayName = BaseInput.name;

    constructor(props) {
        super(props);

        let validateOnChange = true;

        if (!typing.isEmpty(this.props.validateOnChange)) {
            validateOnChange = this.props.validateOnChange;
        }

        this.state = {
            value: this.getValue(),
            initialValue: this.props.value,
            placeholder: this.props.placeholder,
            validators: validation.getValidators(props.tableName, props.fieldName, props.validations),
            isValid: true,
            validateOnChange: validateOnChange,
            row: this.props.row || {}
        };

        this.handleChange = this.handleChange.bind(this);

        if (props.includeValidableComponent) {
            props.includeValidableComponent(this);
        }

    }

    handleOnBlur(event) {
        if (this.props.handleOnBlur) {
            this.props.handleOnBlur(event);
        }
    }

    getValue() {
        if (this.props.files) {
            return this.props.files;
        }
        else {
            return this.props.value;
        }
    }

    validate() {
        const self = this;

        const value = self.state.value;

        return new Promise(function (resolve, reject) {
            if (self.state.validators && self.state.validators.length > 0) {

                const mappedValidators = self.state.validators.map(
                    function (validator) {
                        return validator(value, self.props.tableName, self.props.fieldName, self.props.row || {});
                    });

                Promise.all(mappedValidators).then(
                    validationResults => {
                        const result = validation.getResultSimplifiedForField(validationResults);

                        if (result.valid) {
                            if (!self.state.isValid) {
                                self.setState({ isValid: true });
                            }
                        }
                        else {
                            if (self.state.isValid || self.state.validation_text !== result.validation_text) {
                                self.setState({
                                    isValid: false,
                                    validation_text: result.validation_text
                                });
                            }
                        }
                        resolve(validationResults);
                    }
                );
            }
            else {
                resolve([]);
            }
        })
    }

    setValueState(value, callback) {
        const self = this;

        if (value === undefined) {
            value = '';
        }

        const completeCallback = function () {
            if (callback) {
                callback();
            }
        };

        self.setState({ value: value });

        if (self.props.setInputValue) {
            self.props.setInputValue(value, self.props.fieldName);
        }

        if (self.state.validateOnChange && self.state.validators && self.state.validators.length > 0) {

            const mappedValidators = this.state.validators.map(
                function (validator) {
                    return validator(value, self.props.tableName, self.props.fieldName, self.props.row || {});
                });

            Promise.all(mappedValidators).then(
                validationResults => {
                    const result = validation.getResultSimplifiedForField(validationResults);

                    if (result.valid) {
                        if (!this.state.isValid) {
                            this.setState({ isValid: true }, completeCallback);
                        } else {
                            if (completeCallback) {
                                completeCallback();
                            }
                        }
                    }
                    else {
                        if (this.state.isValid || this.state.validation_text !== result.validation_text) {
                            this.setState({
                                isValid: false,
                                validation_text: result.validation_text
                            }, completeCallback);
                        }
                    }
                }
            );
        }
        else {
            completeCallback();
        }
    }

    handleChange(e) {
        e.preventDefault();
        const self = this;

        let value;
        if (e.target.files) {
            value = e.target.files;
        }
        else if (e.target.id === 'tinymce') {
            value = e.target.innerHTML;
        }
        else if (e.target.getContent) {
            value = e.target.getContent();
        }
        else if (e.date) {
            value = e.date;
        }
        else if (e.target.value) {
            value = e.target.value;
        }
        else if (e.target.innerText) {
            value = e.target.innerText;
        }

        self.setValueState(value);
    }

}


